import { render } from "./ComparePanel.vue?vue&type=template&id=127d1187&scoped=true"
import script from "./ComparePanel.vue?vue&type=script&lang=js"
export * from "./ComparePanel.vue?vue&type=script&lang=js"

import "./ComparePanel.vue?vue&type=style&index=0&id=127d1187&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d1187"]])

export default __exports__